import {ActiveStatus} from 'src/app/shared/model/survey-association-my-suffix.model';
import {ICurrencies} from './currencies.model';
import { FileDataMySuffix, IFileDataMySuffix } from './file-data-my-suffix.model';
import {IInsuranceCompanyMySuffix,InsuranceCompanyMySuffix} from './insurance-company-my-suffix.model';
import {IUmr,Umr} from './umr.model';
import {IUnderwriterMySuffix} from './underwriter-my-suffix.model';


export interface IDelegation {
    id?: number;
    lastModifiedBy?: string;
    lastModifiedByUserRole?: string;
    delegationNumber?: number;
    inceptionDate?: string;
    expiryDate?: string;
    delegationLimit?: number;
    limitCurrency?: number;
    limitCurrencyName?: string;
    activeStatus?: ActiveStatus;
    insuranceCompanySecurity?:  InsuranceCompanySecurity[];
    underwriter?: IUnderwriterMySuffix;
    isDraft?: boolean;
    draftContent?: string;
    strInceptionDate?: string;
    strExpiryDate?: string;
    name?: string;
    delNumberWithUnderwriter?: string;
    forRenew?: boolean;
    currency?: ICurrencies[];
    fileDTO?: IFileDataMySuffix;
}

export class Delegation implements IDelegation {
    constructor(
        public id?: number,
        public lastModifiedBy?: string,
        public lastModifiedByUserRole?: string,
        public delegationNumber?: number,
        public inceptionDate?: string,
        public expiryDate?: string,
        public delegationLimit?: number,
        public limitCurrency?: number,
        public limitCurrencyName?: string,
        public activeStatus?: ActiveStatus,
        public insuranceCompanySecurity?:  InsuranceCompanySecurity[],
        public underwriter?: IUnderwriterMySuffix,
        public isDraft?: boolean,
        public draftContent?: string,
        public strInceptionDate?: string,
        public strExpiryDate?: string,
        public name?: string,
        public delNumberWithUnderwriter?: string,
        public forRenew?: boolean,
        public currency?: ICurrencies[],
        public fileDTO = new FileDataMySuffix(),
    ) {
        this.activeStatus=ActiveStatus.ACTIVE;
        this.delegationLimit=0;
        this.insuranceCompanySecurity=[new InsuranceCompanySecurity()];
        this.isDraft=false;
    }
}

export class InsuranceCompanySecurity{
    constructor(
        public id?: number,
        public insuranceCompany?: IInsuranceCompanyMySuffix,
        public umr?:IUmr,
        public share?: number,
        public shareAmount?: number,
        public shareAmountCurrencyName?: string,
        public shareAmountCurrencyRateToEUR?: number,
        public convertedShareAmount?: number,            // this rate will be converted rate from delegation currency to EUR
        public insurerAuthLimitCurrencyName?: string,
        public authLimitAmountCurrencyRateToEUR?: number,
        public convertedAuthLimitAmount?: number,       // this rate will be converted rate from auth limit currency to EUR
        public currencyRateDateTime?: string,
        public underwriterInsurerId?: number
        
    ){
        this.share=0;
        this.shareAmount=0;
        this.insuranceCompany=new InsuranceCompanyMySuffix();
        this.umr=new Umr();
        this.shareAmountCurrencyRateToEUR=0;
        this.convertedShareAmount=0;
        this.authLimitAmountCurrencyRateToEUR=0;
        this.convertedAuthLimitAmount=0;
    }
}